import { NgModule } from '@angular/core';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { DateTimeAdapter, OwlDateTimeModule, OwlNativeDateTimeModule } from 'ng-pick-datetime';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { BsDatepickerModule, BsDropdownModule, TooltipModule } from 'ngx-bootstrap';
import { CarouselModule } from 'ngx-bootstrap/carousel';
import { NgcCookieConsentConfig, NgcCookieConsentModule } from 'ngx-cookieconsent';
import { environment } from '../../environments/environment.prod';
import { CustomDateTimeAdapter } from '../core/adapters/date-time-adapter';
import { CoreModule } from '../core/core.module';
import { CamposPlantillaComponent } from '../home/formulario-plantilla/campos-plantilla/campos-plantilla.component';
import { BusquedaInventarioComponent } from '../home/inventarios/busqueda-inventario/busqueda-inventario.component';
import { SharedModule } from '../shared/shared.module';
import { BeadcrumbComponent } from './beadcrumb/beadcrumb.component';
import { CabeceraComponent } from './cabecera/cabecera.component';
import { ContentComponent } from './content/content.component';
import { CustomSelectComponent } from './custom-select/custom-select.component';
import { DragComponent } from './drag/drag.component';
import { ErrorPageComponent } from './error-page/error-page.component';
import { ExportTableComponent } from './export-table/export-table.component';
import { CheckInputComponent } from './field-buttons/check-input/check-input.component';
import { DateTimeButtonComponent } from './field-buttons/date-time-button/date-time-button.component';
import { NumberSpinButtonComponent } from './field-buttons/number-spin-button/number-spin-button.component';
import { PasswordProgressBarComponent } from './field-buttons/password-progress-bar/password-progress-bar.component';
import { PickListButtonComponent } from './field-buttons/pick-list-button/pick-list-button.component';
import { PickListViewdataComponent } from './field-buttons/pick-list-viewdata/pick-list-viewdata.component';
import { DateRangeInputComponent } from './field-inputs/date-range-input/date-range-input.component';
import { TextRangeInputComponent } from './field-inputs/text-range-input/text-range-input.component';
import { CarouselFileViewerComponent } from './file/carousel-file-viewer/carousel-file-viewer.component';
import { FileElementComponent } from './file/file-element/file-element.component';
import { FileComponent } from './file/file.component';
import { ListFileViewerComponent } from './file/list-file-viewer/list-file-viewer.component';
import { FiltrosTablasComponent } from './filtros-tablas/filtros-tablas.component';
import { FooterComponent } from './footer/footer.component';
import { HeaderComponent } from './header/header.component';
import { MainmenuComponent } from './mainmenu/mainmenu.component';
import { MenuimpresiondocumentosComponent } from './menuimpresiondocumentos/menuimpresiondocumentos.component';
import { ModalConfirmationComponent } from './modal-confirmation/modal-confirmation.component';
import { ModalShowTextComponent } from './modal-show-text/modal-show-text.component';
import { MulticlientSelectorComponent } from './multiclient-selector/multiclient-selector.component';
import { NotfoundComponent } from './notfound/notfound.component';
import { SidebarComponent } from './sidebar/sidebar.component';

const cookieConfig: NgcCookieConsentConfig = {
  cookie: {
    domain: environment.API_DOMAIN // Modificar
  },
  palette: {
    popup: {
      background: '#000'
    },
    button: {
      background: '#f1d600'
    }
  },
  theme: 'classic',
  type: 'info',
  content: {
    message:
      'Utilizamos cookies propias y de terceros para mejorar la experiencia del usuario a través de su navegación. '
      + 'Si continúas navegando aceptas su uso.',
    dismiss: 'Aceptar',
    href: 'http://www.docout.es/politica-de-privacidad-y-cookies/', // Modificar correctamente
    link: 'Política de privacidad'
  }
};

@NgModule({
  imports: [
    NgxDatatableModule,
    NgcCookieConsentModule.forRoot(cookieConfig),
    SharedModule,
    CoreModule,
    CarouselModule.forRoot(),
    OwlDateTimeModule,
    OwlNativeDateTimeModule,
    BsDatepickerModule,
    BsDropdownModule,
    NgSelectModule,
    TooltipModule.forRoot(),
    PdfViewerModule,
  ],
  exports: [
    BeadcrumbComponent,
    CabeceraComponent,
    ContentComponent,
    FooterComponent,
    HeaderComponent,
    MainmenuComponent,
    SidebarComponent,
    NotfoundComponent,
    CustomSelectComponent,
    ModalConfirmationComponent,
    DragComponent,
    BusquedaInventarioComponent,
    FileComponent,
    ModalShowTextComponent,
    CheckInputComponent,
    CarouselModule,
    CarouselFileViewerComponent,
    FileElementComponent,
    ListFileViewerComponent,
    DateTimeButtonComponent,
    FiltrosTablasComponent,
    NumberSpinButtonComponent,
    PickListButtonComponent,
    ExportTableComponent,
    TextRangeInputComponent,
    DateRangeInputComponent,
    PasswordProgressBarComponent,
    PickListViewdataComponent,
    CamposPlantillaComponent,
    MenuimpresiondocumentosComponent
  ],
  declarations: [
    BeadcrumbComponent,
    CabeceraComponent,
    ContentComponent,
    FooterComponent,
    HeaderComponent,
    MainmenuComponent,
    SidebarComponent,
    NotfoundComponent,
    CustomSelectComponent,
    ModalConfirmationComponent,
    DragComponent,
    BusquedaInventarioComponent,
    FileComponent,
    ModalShowTextComponent,
    CheckInputComponent,
    CarouselFileViewerComponent,
    ListFileViewerComponent,
    FileElementComponent,
    DateTimeButtonComponent,
    FiltrosTablasComponent,
    NumberSpinButtonComponent,
    PickListButtonComponent,
    ExportTableComponent,
    TextRangeInputComponent,
    DateRangeInputComponent,
    PasswordProgressBarComponent,
    PickListViewdataComponent,
    MulticlientSelectorComponent,
    ErrorPageComponent,
    CamposPlantillaComponent,
    MenuimpresiondocumentosComponent
  ],
  entryComponents: [
    ModalConfirmationComponent,
    ModalShowTextComponent,
    MenuimpresiondocumentosComponent
  ],
  providers: [
    { provide: DateTimeAdapter, useClass: CustomDateTimeAdapter }
  ]
})
export class UtilsModule { }
